module.exports = __webpack_public_path__ + "fonts/fa-brands-400---d72293118cda50ec50c39957d9d836d0.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@fortawesome/fontawesome-free/webfonts/fa-brands-400.svg
// module id = 374
// module chunks = 0